<template>
	<div class="demand">
		<header>
            <Header />
        </header>
		<main>
            <section class="detail-content-box">
                <div class="container">
                    <div class="row content-box">
                        <div class="content-wrapper-title">{{newsParam.newsTitle || '-'}}</div>
                        
                        <div class="content-wrapper-tag">
                            <div class="tag-date">阅读次数:{{newsParam.scanNum || '0'}}次</div>
                            <div class="tag-date">发布时间:{{newsParam.insertTime || '-'}}</div>
                            <div class="tag-cate">{{newsParam.newsCate || '-'}}</div>
                            
                        </div>
                        <img class="content-wrapper-img" :src="newsParam.bannerImage" alt="new-img">
                        <p class="content-wrapper">{{ newsParam.newsContent || '-' }}</p>
                    </div>
                    <div class="row is-back">
                        <div class="fanhui" @click="$router.push({path:'/news'})">
                            返回列表
                        </div>
                    </div>
                </div>
                
            </section>
		</main>
		<!-- <footer><Footer /></footer> -->
	</div>
</template>

<script>
import Header from '../../components/header.vue';
// import Footer from '../../components/footer.vue';
import {
    newsDetail
} from '@/api/index.js'
export default {
  	name: 'Home',
	components: {
		Header,
		// Footer
	},
	data() {
		return {
            newsParam:{},
		};
		
		
	},
	mounted() {
        this.getNewsDetail();
	},
    methods:{
        async getNewsDetail(){
            let id = sessionStorage.getItem('newsId');
            const data = await newsDetail(id);
            this.newsParam = data.data;
        }
    }
}
</script>
<style lang="scss" scoped>
.demand{
    position:absolute;
    top:0;
    left:0;
    bottom:0;
    right:0;
    width:100%;
    height:100%;
    background-color: #f9fafb;
}
header {
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0 0.2rem 0.6rem 0 #0000001a;
    position: sticky;
    top: 0;
    z-index: 99;
}
.detail-content-box{
    width:100%;
    height:auto;
     padding:20px 0 20px;
    background-color: #f9fafb;
    .content-box{
        min-height:400px;
        margin:0 auto;
        .content-wrapper-title{
            width:100%;
            height:auto;
            text-align: center;
            font-size:1.25rem;
            font-weight:600;
        }
        .content-wrapper-tag{
            width:100%;
            height:40px;	
            margin:10px 0;
            color:#999;
            border-top:1px dashed #ccc;
            border-bottom:1px dashed #ccc;
            display: flex;
            justify-content: flex-end;
            .tag-date{
                text-align:right;
                line-height:40px;
                margin-right:10px;
            }
            .tag-cate{
                margin-top:5px;
                height:30px;
                // line-height:30px;
                font-size:13px;
                box-sizing: border-box;
                padding:5px 10px;
                color:#409EFF;
                border-radius:5px;
                background-color: #dbeafe;
            }
        }
        .content-wrapper-img{
            display:block;
            width:300px;
            min-height:300px;
            margin:0 auto;
        }
        .content-wrapper{
            width:100%;
            height:auto;
            padding:20px 0;
            text-indent: 2em;
            text-align: justify;
            font-size:0.9rem;
        }
    }
}
.is-back{
    width: 100%;
    height:2rem;
    .fanhui{
        width:5rem;
        line-height:2rem;
        margin:0 auto;
        text-align:center;
        background:#00a271;border-radius:1.25rem;
        font-size:15px;
        color:#fff;
        transition:.36s
    }
}
.is-back:hover{
    .fanhui{
        cursor: pointer;
        background:#9fca37;
    }
}
</style>


